import { useContext } from 'use-context-selector';

import { OffersContext } from 'Contexts/OffersContext';

export default function useOffers() {
  return useContext(OffersContext);
}
